import { connect } from "react-redux"

import { removeAlert } from "../../actions/alert-actions"

import Alert from "./Alert"

const mapDispatchToProps = (dispatch, props) => ({
    ...props,
    dismiss: id => dispatch(removeAlert(id))
})

export default connect(null, mapDispatchToProps)(Alert)
